import React from "react";
import classnames from "classnames";

const Table = ({ columns, rows }) => {
  return (
    <table className="f6 w-100 mw8 center ba b--black-10 br2" cellSpacing="0">
      <thead>
        <tr>
          {columns.map((column, columnIx) => (
            <th key={columnIx} className="fw6 bb b--black-10 tl pa3">
              {column}
            </th>
          ))}
        </tr>
      </thead>
      <tbody className="lh-copy">
        {rows.map((row, rowIx) => (
          <tr key={rowIx}>
            {row.map((cell, cellIx) => (
              <td
                key={cellIx}
                className={classnames("pa3", {
                  "bb b--black-10": rowIx !== rows.length - 1
                })}
              >
                {cell}
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default Table;
